/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useMemo} from 'react';
// redux
import {useDispatch, useSelector} from 'react-redux';
// todo get fetchAccountProducts working from the account state slice, reverted to old logic for hotfix
import {fetchAccountProducts} from "../../../../state/thunks/account";

import {
  fetchCodeForSite,
  fetchTrendingNowCodeForSite,
  PRODUCT_ARTICLE_SENTIMENT,
  PRODUCT_TRENDING_NOW
} from '../../../../state/thunks/engagement';
// material
import {Content, Page, InContentMessage} from '@insticator/insticator-ui';
import PageHeader from '../../../../material/structure/pageheader/pageheader';
import PageContent from '../../../../material/structure/pagecontent/pagecontent';
import SentimentCode from './sentiment/sentiment';
// styles
import injectSheet from 'react-jss';
import styles from './getcode_styles';
import EngagementHeader from "../engagementHeader";
import TrendingNowCode from "./trending/trending";



/* ========== ~~~~~~~~~~ GET CODE PAGE - ENGAGEMENT ~~~~~~~~~~ ========== */
const GetCodePage = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const {
    session: {
      siteUUID,
      accountUUID
    },
    engagement: {
      accountProducts,
    }
  } = useSelector((state) => state);

  const hasArticleSentimentAccess = useMemo(() =>
      accountProducts.includes(PRODUCT_ARTICLE_SENTIMENT)
    , [accountProducts]
  )

  const hasTrendingNowAccess = useMemo(() =>
      accountProducts.includes(PRODUCT_TRENDING_NOW)
    , [accountProducts]
  )

  useEffect(() => {
    if (!accountUUID) return;
    dispatch(fetchAccountProducts(accountUUID))
  }, [dispatch, accountUUID])

  useEffect(() => {
    if (siteUUID) {
      dispatch(fetchCodeForSite(siteUUID))
    }
  }, [siteUUID, dispatch])

  useEffect(() => {
    if (siteUUID) {
      dispatch(fetchTrendingNowCodeForSite(siteUUID))
    }
  }, [siteUUID, dispatch])

  return (
    <Page name={'getcode'}>
      <EngagementHeader />
      <Content>
        <InContentMessage />
        <PageHeader title={'Trends & Reactions'} subtitle={'Get Code'}/>
        <PageContent>
          {hasArticleSentimentAccess && <SentimentCode/>}
          {hasTrendingNowAccess && <TrendingNowCode/>}
        </PageContent>
      </Content>
    </Page>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default GetCodePage;
